import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  submitOnEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.element.requestSubmit()
    }
  }

  submit() {
    this.element.requestSubmit()
  }
}
